{
  "01_Auf-Abgaenge": "Stairs, lifts",
  "01_Evakuation": "Evacuation",
  "01_Gebote_Verbote": "Rules, prohibitions",
  "01_gefahren": "Dangers traffic",
  "01_Gleise": "Tracks",
  "01_Richtungen": "Directions",
  "01_Verkehrsmittel": "Means of transport",
  "010_Basic": "Basic",
  "02_Brandbekaempfung": "Fire Fighting",
  "02_Entsorgung_Recycling": "Disposal, recycling",
  "02_Parkieren": "Parking",
  "02_Sektoren": "Sectors",
  "02_verbote": "Prohibitions traffic",
  "020_Arrow": "Arrows",
  "03_Barrierefreiheit": "Accessibility",
  "03_gebote": "Mandatory traffic",
  "03_Hygiene": "Hygiene",
  "03_vorschriftszeichen": "Regulatory signs",
  "04_Dienstleistungen": "Services",
  "04_Funktionsweise": "Functionalities",
  "04_Klassen": "Classes",
  "04_rest": "Other traffic",
  "06_richtzeichen": "Indicational",
  "080_Timetable": "Accessibility",
  "10_zusatzzeichen": "Additional signs",
  "110_Location": "Location",
  "190_Installation": "Installations",
  "ab": "from",
  "Abbrechen": "Cancel",
  "Abmelden": "Log out",
  "Absenden": "Send",
  "Achtung": "Warning",
  "admin_settings": "Administrator settings",
  "aerial": "Satellite",
  "Aktuelle Zoomstufe": "Current zoom level",
  "Aktueller Stand des Elements": "Current element's level",
  "Alle Tags entfernen": "Remove all tags",
  "already in use for another drawing by this user.": "Name already in use.",
  "Als PNG speichern": "Save as PNG",
  "Als Standardplan festlegen": "Set as default plan",
  "Am rechten Rand andocken": "Dock to the right",
  "andere": "other",
  "Andocken lösen": "Undock",
  "Änderungen konnten nicht gespeichert werden": "Changes could not be saved",
  "Änderungen werden gespeichert": "Saving changes",
  "Anfang Icon": "Beginning icon",
  "Anfrage versenden": "Send request",
  "anfrage_form_success": "Thank you for your inquiry. We will contact you as soon as possible.",
  "Anwenden": "Apply",
  "Auf Ausschnitt zentrieren": "Centre on clip section",
  "Auf Route zentrieren": "Zoom on Route",
  "Auf Zoomstufen beschränken": "Limit to zoom level",
  "aufgaenge": "Ascents and descents",
  "Auflösung": "Resolution",
  "Aus": "Off",
  "Ausgewählte Elemente": "Selected elements",
  "Ausrichtungshilfe": "Alignment aid",
  "Ausschnitt festlegen": "Set clip dimensions",
  "Ausschnitt sperren": "Lock clip section",
  "Ausser Zoomstufen Zoombeschränkung": "The selected zoom restriction is outside the currently visible area.",
  "bahnlinien": "Railway lines",
  "bahnofplan": "Station plans",
  "Barrierefreie Route": "Accessible route",
  "Baselayers": "Background",
  "basemap": "Network Map",
  "Bearbeiten": "Edit",
  "Benutzeranleitung": "User guide",
  "Betreiber": "Operator",
  "bike": "Bike",
  "Bild einfügen": "Insert picture",
  "Bild herunterladen": "Download plan",
  "bis": "until",
  "Bitte geben Sie einen Plannamen ein.": "Please enter a plan name.",
  "Bitte loggen Sie sich ein, um die Zeichnung zu exportieren.": "Please log in to export the drawing.",
  "Bitte, Copyright zu kopieren": "Export size too small to display the copyright properly. Please make sure the following copyright appears in your publication:",
  "Branche": "Sector",
  "Bus": "Bus",
  "bus": "Bus",
  "buslinien": "Bus lines",
  "Car": "Car",
  "car": "Car",
  "Coach": "Coach",
  "coach": "Coach",
  "colorful": "Colorful map",
  "Confirm remove plan": "Are you sure you want to remove this plan from your profile?",
  "Construction": "Construction",
  "Copyright kopiert!": "Copyright copied!",
  "custom_layout_dialog_description": "You can integrate and export your plan directly in mapset in a PDF template. We design the templates according to your wishes regarding format, logo and corporate design as well as the placement of texts and other elements. Send us a message using this form and we will get in touch with you.",
  "custom_layout_dialog_title": "Create a custom layout",
  "custom_layout_placeholder_message": "I am interested in a custom PDF layout. Please contact me at {{user.email}}.",
  "custom_layout_placeholder_title": "Create mapset layout for {{user.email}}",
  "Datenschutz": "Privacy policy",
  "Den bestehenden Plan können sie mit folgendem Link jederzeit weiter bearbeiten.": "You can edit the existing plan any time with the following link.",
  "Der aktuelle Anmelde-Status hat sich geändert. Bitte laden Sie die Seite neu.": "The current login status has changed. Please reload the page.",
  "Der geladene Plan ist ein Standardplan. Sie haben keine Rechte, um Standard-Pläne zu bearbeiten.": "The loaded plan is a standard plan. You have no rights to edit standard plans.",
  "Der Plan wurde geändert": "The plan was changed",
  "Dialog nicht mehr anzeigen": "Do not show this dialog again",
  "Did you know?": "Did you know?",
  "Die Zeichnung konnte nicht geladen werden.": "The drawing could not be loaded.",
  "Die Zeichnung konnte nicht geladen werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "The drawing could not be loaded. Please check your internet connection and try again.",
  "Die zu exportierende Fläche ist zu groß. Die maximal zulässige Größe ist ": "The area to be exported is too large. The maximum size allowed is ",
  "Diese Pikto-Gruppe besteht aus": "This group consists of",
  "Dieser Plan wurde nicht von Ihnen erstellt. Was möchten Sie tun?": "This plan was not created by you. How do you want to proceed?",
  "Dieser Plan wurde ursprünglich nicht von Ihnen benannt. Durch Ihre Änderungen wird der Planname für andere User auch aktualisiert.": "This plan was not originally named by you. Your changes will also update the plan name for other users.",
  "drawinfo.default_for": "Plan type",
  "drawinfo.name": "Plan name",
  "drawinfo.provider": "Operator",
  "drawinfo.station_identifier": "Station id",
  "drawinfo.station_name": "Station name",
  "drawinfo.valid_from": "Valid from",
  "drawinfo.valid_to": "Valid to",
  "drawinfo.viewLinkValidity": "Validity of the default plan",
  "Drehung": "Rotation",
  "Dreieck zeichnen": "Draw triangle",
  "Ebenen": "Layers",
  "editor_disabled_tooltip_picture": "only available from zoom level 15",
  "editor_group_area": "Draw areas",
  "editor_group_line": "Draw lines",
  "editor_group_point": "Draw points",
  "Eine Position nach oben": "Bring forward",
  "Eine Position nach unten": "Send backward",
  "Einloggen": "Log in",
  "Einstellungen": "Settings",
  "Element auswählen": "Select element",
  "Element löschen": "Delete feature",
  "Element wurde in die Zwischenablage kopiert": "Feature copied to clipboard.",
  "Elemente löschen": "Delete features",
  "Ende Icon": "End icon",
  "Entfernen": "Remove",
  "Error": "Error",
  "Etwas ist schief gelaufen.": "Something went wrong.",
  "Events": "Events",
  "Export im geteilten Plan ermöglichen": "Enable export in shared plan",
  "Export Optionen": "Export Options",
  "export_kml_description": "Download your plan as KML to use it in other tools.\n\n<italic>Please note that the representation of the plan in KML may differ from mapset.</italic>",
  "export_type_image": "Image",
  "export_type_kml": "KML",
  "export_type_pdf": "PDF",
  "export_width_too_small_message": "The area to be exported is too small. Please increase the frame width to {{width}} pixels to display all elements in the template correctly.",
  "Exportieren": "Export",
  "Externe kommerzielle Einrichtungen": "External commercial facilities",
  "Fallend": "Descending",
  "Farbe ändern": "Change color",
  "feature_styler_title_area": "Area settings",
  "feature_styler_title_icon": "Icon settings",
  "feature_styler_title_icon_group": "Icon group settings",
  "feature_styler_title_label": "Label settings",
  "feature_styler_title_line": "Line settings",
  "feature_styler_title_picture": "Picture settings",
  "feature_styler_title_unknown": "Style editor",
  "feature_type_area": "Area",
  "feature_type_icon": "Icon",
  "feature_type_icon_group": "Icon group",
  "feature_type_label": "Label",
  "feature_type_line": "Line",
  "feature_type_picture": "Picture",
  "feature_type_unknown": "Element",
  "feedback_form_error": "Sorry, your message could not be sent. We are trying to correct the problem as soon as possible.",
  "feedback_form_file_helper_text": "Accepted formats: {{formats}}",
  "feedback_form_success": "Thank you for your feedback. We will give you feedback as soon as possible.",
  "feedback_form_text": "You have found an error in mapset or have a suggestion for improvement? Report it to us using this form.\n\nThe best way to document errors in the base map is by drawing the correct situation on the map directly in mapset. Your drawing will automatically be added to the feedback as a link. Alternatively, you can attach your own image.",
  "Ferry": "Ferry",
  "ferry": "Ferry",
  "File size too big": "Files size too big, max. {{size}}MB.",
  "Fläche zeichnen": "Draw polygon",
  "Flächen-Transparenz": "Fill transparency",
  "Flächenfarbe": "Area color",
  "foot": "Foot",
  "form_attachment": "Attachments",
  "form_message": "Message",
  "form_title": "Subject",
  "Format": "Format",
  "Fortschritt gespeichert": "Progress saved",
  "Fortschritt speichern": "Save",
  "Fortschritt wird gespeichert": "Save in progress",
  "Funicular": "Funicular",
  "funicular": "Funicular",
  "Für den Export von PDF-Layouts müssen Sie eingeloggt sein.": "You need to be logged in to export PDF layouts.",
  "Fussgänger": "Foot",
  "fusswege": "Footpaths",
  "Ganzer Plan": "Whole plan",
  "gebirgsnamen": "Mountain names",
  "Gebote": "Mandatory",
  "Gefahren": "Danger",
  "gewässerlabel": "Water labels",
  "Gondola": "Gondola",
  "gondola": "Gondola",
  "gross": "large",
  "Grösse": "Size",
  "Gruppierung aufheben": "Ungroup",
  "guide.customlayout": "pdftemplate",
  "guide.downloadplan": "downloadplan",
  "guide.drawarea": "drawarea",
  "guide.drawicon": "drawicon",
  "guide.drawlabel": "drawlabel",
  "guide.drawline": "drawline",
  "guide.drawroute": "drawroute",
  "guide.feedback": "feedback",
  "guide.insertpicture": "insertpicture",
  "guide.layertoggler": "layertoggler",
  "guide.newplan": "newplan",
  "guide.plandefault": "defaultplans",
  "guide.plannamesandlist": "plannamesandlist",
  "guide.plansaveconfirm": "saveplanconfirm",
  "guide.plansaving": "saveplan",
  "guide.plansharing": "plansharing",
  "guide.settings": "settings",
  "guide.tags": "plans-with-tags",
  "Halt entfernen": "Remove stop",
  "Halt hinzufügen": "Add stop",
  "haltekanten": "Stop edges",
  "Haltestelle": "Station",
  "Haltestelle suchen": "Search station",
  "haltestellen": "Stops",
  "haltestellenschilder": "Stop signs",
  "Hide at next startup": "Hide at next startup",
  "Hilfslinien": "Auxiliary lines",
  "Hineinzoomen": "Zoom in",
  "Hintergrundfarbe": "Background color",
  "hoch": "high",
  "Hochladen": "Choose files",
  "hotkeys.featureDelete": "also with Del or backspace",
  "hotkeys.featureFreehand": "freehand drawing using Shift + left mouse button",
  "hotkeys.featureGroup": "also with Ctrl + G",
  "hotkeys.featureIconMultiselect": "multiple selection using Ctrl + click on icon",
  "hotkeys.featureUngroup": "also with Ctrl + Shift + G",
  "hotkeys.mapRotate": "rotate map using Alt + Shift + map pan",
  "icone_trenord": "Trenord icons",
  "Icons": "icons",
  "Icons suchen": "Search icons",
  "Ihre Änderungen konnten nicht gespeichert werden. Bitte kontrollieren Sie Ihre Internet-Verbindung und versuchen Sie es erneut.": "Your changes could not be saved. Please check your internet connection and try again.",
  "Impressum": "Imprint",
  "Individuell": "Custom",
  "Information zur Reisekette 1": "Traveller information 1",
  "Information zur Reisekette 2": "Traveller information 2",
  "Inspect-Modus": "Inspect mode",
  "Interne kommerzielle Einrichtungen": "Internal commercial facilities",
  "Jetzt loslegen": "Start now",
  "Kartenausrichtung zurücksetzen": "Reset map rotation",
  "kein": "none",
  "Kein Plan vorhanden. Bitte erstellen Sie zuerst einen Plan.": "No current plan available. Please create a plan first.",
  "kein QR-Code": "no QR code",
  "Keine Icons gefunden.": "No icons found.",
  "Keine Pläne verfügbar.": "No plans available.",
  "klein": "small",
  "Kontur-Transparenz": "Outline transparency",
  "Konturbreite": "Outline width",
  "Konturfarbe": "Outline color",
  "Konturtype": "Outline type",
  "Kopie": "copy",
  "Kopieren": "Copy",
  "Kopiertes Element wurde eingefügt": "Copied feature inserted.",
  "Kreis zeichnen": "Draw circle",
  "Kreuzweise": "Hatch",
  "Laden...": "Loading...",
  "Lageplan": "Other facilities",
  "landscape": "landscape",
  "linee_trenord": "Trenord lines",
  "Linie": "Line",
  "Linie zeichnen": "Draw line",
  "Linien-Transparenz": "Transparency",
  "Linienabschluss": "Line end",
  "Linienanfang": "Line start",
  "Linienbreite": "Line width",
  "Linientyp": "Line type",
  "Link kopiert!": "Link copied!",
  "Link zum Bearbeiten": "Link to edit",
  "Link zum Teilen": "Link to share",
  "mapset_layout_description": "Description",
  "mapset_layout_description_placeholder": "Plan <b>description</b> ...",
  "mapset_layout_title": "Title",
  "mapset_layout_title_placeholder": "Title ...",
  "Maximale Anzahl an Haltestellen erreicht": "Maximum number of stops reached",
  "Meine Vorlage": "My layout",
  "Mit diesem Link können Sie den Plan jederzeit weiter bearbeiten. Um die jetzige Version zu behalten, speichern Sie bitte diesen Link und erstellen dann einen": "Use this link to continue editing previously created plans. To save your current version, copy and store this link, then create a",
  "Mit dieser Aktion wird der aktuelle Plan entfernt und ein neuer Plan gestartet. Wollen Sie wirklich einen neuen Plan erstellen?": "This action will erase the current plan and start a new one. Do you really want to create a new plan?",
  "mittel": "medium",
  "mostUsed": "Most used",
  "Muster": "Fillpattern",
  "Nach ganz oben verschieben": "Bring to front",
  "Nach ganz unten verschieben": "Send to back",
  "Nach Tags filtern...": "Filter by tags...",
  "neuen Plan": "new plan",
  "Neuen Plan anlegen": "Create new plan",
  "Neuen Tag erstellen": "Create new tag",
  "Neuer Plan": "New plan",
  "neutrino": "Neutral map",
  "NewPlan": "This action starts a new plan. Do you really want to continue?",
  "Next Tip": "Next Tip",
  "none": "Other",
  "Nordpfeil": "North arrow",
  "normal": "normal",
  "Nur durch Hilfslinien oder Ankerpunkten angeordnete Piktogramme behalten die Ausrichtung und Reihenfolge bei.": "Only icons aligned by auxiliary lines or anchor points maintain the orientation and sequence.",
  "Öffnen": "Open",
  "Organisation": "Organization",
  "Ort": "location",
  "Ort, Adresse, Haltestelle": "Place, address, station",
  "ortslabel": "Place names",
  "Ortung im geteilten Plan ermöglichen": "Enable location in shared plan",
  "pärke": "Green areas",
  "Pflichtfeld": "Required fields",
  "Piktogramm zeichnen": "Draw Icon",
  "Piktogramm-Ankerpunkte": "Icon anchor points",
  "Piktogramme": "pictogramms",
  "Piktogramme gruppieren": "Group icons",
  "Piktogramme selektiert": "icons",
  "Piktogrammen": "icons",
  "Plan bearbeiten": "Edit plan",
  "Plan benennen": "Name plan",
  "Plan duplizieren": "Duplicate plan",
  "Plan entfernen": "Plan removal",
  "Plan exportieren": "Export plan",
  "Plan löschen": "Delete plan",
  "Plan speichern": "Save plan",
  "Plan teilen": "Share plan",
  "Plan überschreiben": "Overwrite plan",
  "Plan wechseln": "Switch plan",
  "Planliste": "Plans list",
  "Planname": "Plan name",
  "pois": "POIs",
  "portrait": "portrait",
  "Previous Tip": "Previous Tip",
  "QR-Code": "QR code",
  "QR-Code herunterladen": "Download QR code",
  "Quadrat zeichnen": "Draw square",
  "rail": "Train",
  "Rauszoomen": "Zoom out",
  "Route kann für dieses Verkehrsmittel nicht berechnet werden!": "Route cannot be processed for this mean of transport!",
  "Route kreieren": "Create route",
  "Route wird berechnet": "Loading route...",
  "Route zeichnen": "Draw route",
  "Routen-Finder": "Route-Finder",
  "Routenlänge": "Route length",
  "saturated": "Network Map Saturated ",
  "SavePlanMessage": "You can edit the current plan any time with the name <b>{{name}}</b> or with the following link.",
  "schiffslinien": "Ferry lines",
  "Schliessen": "Close",
  "Schreibgeschützt fortfahren": "Continue in read-only mode",
  "Schriftkontur": "Font outline",
  "sehr hoch": "very high",
  "seilbahnen": "Cablecars",
  "Seite neu laden": "Reload page",
  "selektieren": "Select {{plan}}",
  "Serviceeinrichtungen": "Services",
  "Show tips at startup": "Show tips at startup",
  "Sicherheitseinrichtungen": "Security",
  "Sie haben": "You selected",
  "Sie müssen eingeloggt sein, um diese Funktion nutzen zu können.": "You need to be logged in to use these services.",
  "Sie müssen eingeloggt sein, um diese Funktion weiterhin nutzen zu können.": "You need to be logged in to continue using these services.",
  "Sie müssen erst einen Plan erstellen.": "You have to create a plan first.",
  "Sie sind zur Zeit nicht angemeldet. Melden Sie sich an um mit der Bearbeitung fortzufahren, oder erstellen Sie einen neuen Plan.": "You are currently logged out. Please log in to continue editing, or create a new plan.",
  "Sie werden von allen geOps-Diensten abgemeldet.": "Logging you out from all geOps services.",
  "Snapping aktivieren": "Activate snapping",
  "Speichern": "Save",
  "Sprache": "Language",
  "Standard": "Standard",
  "Standard plan ist bereit": "You can view this standard plan <a href='{{defaultsUrl}}' {{linkAttributes}}>online</a> for a specific point in time, or you can also <a href='{{defaultPrintUrl}}' {{linkAttributes}}>download it as a PDF</a>.",
  "Standardplan öffnen": "Open default plan",
  "Standort": "Location",
  "Stapelreihenfolge": "Stacking order",
  "Start- und Endpunkte müssen unterschiedlich sein!": "Start and end points must be different!",
  "Steigend": "Ascending",
  "strassen": "Street names",
  "Subway": "Subway",
  "subway": "Subway",
  "Suche nach Plänen": "Search for plans",
  "Suche nach Tags...": "Tag search...",
  "Sucheingabe löschen": "Delete search entry",
  "SwitchPlan": "This action switches to plan <b>{{name}}</b>. Do you really want to continue?",
  "Tag hinzufügen": "Create new tag \"{{name}}\"",
  "tag_add_confirmation": "Newly created tags will be available to other members of your team. \n\n Are you sure you want to add the tag \"{{name}}\"?",
  "Tags": "Tags",
  "Text": "Text",
  "Text hier eingeben": "Insert text here",
  "Text zeichnen": "Draw label",
  "Textausrichtung": "Text alignment",
  "Textfarbe": "Text color",
  "Tippen Sie, um neue Tags zu erstellen": "Type to create new tags",
  "Tram": "Tram",
  "tram": "Tram",
  "tramlinien": "Tram lines",
  "tunnelbeschriftungen": "Tunnel labels",
  "ubahnlinien": "Subway lines",
  "Um alle Funktionen in mapset zu nutzen, benötigt ihre Organisation ein Abonnement für mapset. Wenden Sie sich dazu bitte an support@mapset.ch.": "To use all features in mapset, your organization needs a subscription to mapset. Please contact <a href='mailto:support@mapset.ch' {{linkAttributes}}>support@mapset.ch</a>.",
  "Unbenannter Plan": "Untitled plan",
  "unterfuehrungen": "Underground areas",
  "User abmelden": "Log out {{user.email}}",
  "Validity overlaps with another constrained default plan": "Validity overlaps with another default plan for this station",
  "Verkehrsmittel": "Means of transport",
  "verkehrsmittel": "Means of transport",
  "Verwenden Sie diesen Link, um den Plan an andere Leute weiterzugeben oder in andere Anwendungen einzubinden.": "Use this link to share your plan with others or to embed the plan in other applications.",
  "Vollflächig": "Holohedral",
  "Vorschau": "Preview",
  "Weiter": "Continue",
  "Wenn Ihre Zeichnung fertig ist, klicken Sie auf das rote SBB-Icon, um die Zeichnung im SBB-Webkartenportal anzuzeigen und zu teilen.": "When your drawing is finished, click the red SBB icon to view and share the drawing on the SBB web map portal.",
  "Willkommen in mapset": "Welcome to mapset",
  "Wollen Sie Ihren Plan überschreiben oder eine neue Version des Plans anlegen?": "Do you want to overwrite your plan or create a new version of the plan?",
  "Zeichnung in WKP anzeigen": "Open draw in web map portal",
  "Zeichnung speichern": "Save plan",
  "Zeichnung teilen": "Share plan",
  "Ziehen um die Reihenfolge zu ändern": "Drag to change the order",
  "Zoom-Höchstwert": "Maximum zoom",
  "Zoom-Tiefstwert": "Minimum zoom",
  "Zoomstufen": "Zoom levels",
  "Zug": "Train",
  "Zurück": "Go back",
  "Zurück zum Plan": "Go back to the plan",
  "Zurücksetzen": "Reset",
  "Dein Zugang zu dieser Organisation ist deaktiviert. Bitte wende dich an deinen Admin.": "Your access to this organization has been deactivated. Please contact your admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Bitte wende dich an deinen Admin.": "Your organization's free period has ended. Please contact your admin.",
  "Die Testphase deiner Organisation ist abgelaufen. Wähle einen Plan, um weiterzuarbeiten.": "Your organization's free period has ended. Choose a plan to continue.",
  "Die Einrichtung einer Organisation ist bald verfügbar.": "Organization setup will be available soon.",
  "Organisation einrichten": "Set up organization",
  "Upgrade": "Upgrade"
}
